import React from 'react'
import me from '../../assets/bg.gif'
import './LandPage.css'
import Typewriter from "typewriter-effect";
import { BsTwitter, BsFacebook, BsInstagram, BsEmojiSunglasses } from 'react-icons/bs'
import { AiFillLinkedin } from 'react-icons/ai'


const LandingPage = () => {

  return (

    <>

      <div className='container_top'>

        <div>
          <img src={me} alt='no' className='image' />
        </div>

        <div className='auto_typing'>

          <h2> Hi   <BsEmojiSunglasses /> </h2>
          <h3>I'm GURPREET</h3>

          <Typewriter
            options={{
              strings: [" Full Stack Developer", " UI/UX Desginer", "React Developer"],
              autoStart: true,
              loop: true,
              delay: 40
            }}
          />
          <p>
            React JS ||  React-Redux ||  NodeJS ||  Express ||
          </p> <p>
            MongDB ||  RestFul Api ||  JavaScript
          </p>

          <li><a href='https://ca.linkedin.com/in/gurpreet-singh-ba93891a0'><AiFillLinkedin /></a></li>
          <li><a href='/'><BsFacebook /></a></li>
          <li><a href='/'><BsInstagram /></a></li>
          <li><a href='/'><BsTwitter /></a></li>
          <button> Get Started</button>
        </div>
      </div>

      <div className='skill'>

        <div className='icon'>


        </div>
      </div>




    </>
  )
}

export default LandingPage

// <>

// <title >GURPREET SINGH</title>
// <section>
//   <div className='main'>
//     <header>
//       {/* <img src={me} alt='no' className='image' /> */}
//       <a href='#home' className='logo'>Gurpreet Singh</a>
//       <div className='nav'>
//       <ul >
//         <li><a href='#home'> Home</a></li>
//         <li><a href='#about'> About</a></li>

//         <li><a href='#experience'> Experience</a></li>
//         <li><a href='#contact'> Contact</a></li>


//       </ul>
//       </div>
//     </header>
/* 
    {/* <div className='content'>
      <div className='contentbox'>
        <h2> Hi Gurpreet </h2>

        <h3>
          <div className='text'>
            <Typewriter
              options={{
                strings: ["I am Full Stack Developer", "I am UI/UX Desginer", "I am React Developer"],
                autoStart: true,
                loop: true,
              }}
            />
          </div></h3>
        <p>
          React JS ||  React-Redux ||  NodeJS ||  Express ||
          MongDB ||  RestFul Api ||  JavaScript
        </p>
        <a classNmae="get_started" href='/'>Get Started</a>
      </div>
    </div>
    <div className='sci'>
      <li><a href='/'><BsFacebook /></a></li>
      <li><a href='/'><BsInstagram /></a></li>
      <li><a href='/'><BsTwitter /></a></li>


    </div> */